import { render } from "./ChannelPerformance.vue?vue&type=template&id=356a9af6&scoped=true"
import script from "./ChannelPerformance.vue?vue&type=script&lang=js"
export * from "./ChannelPerformance.vue?vue&type=script&lang=js"

import "./ChannelPerformance.vue?vue&type=style&index=0&id=356a9af6&lang=scss"
import "./ChannelPerformance.vue?vue&type=style&index=1&id=356a9af6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356a9af6"]])

export default __exports__